
import { defineComponent } from 'vue';
import AsideLinkComponent from './AsideLinkComp.vue'
import CategoriesMixins from "@/data/CategoriesMixins";

export default defineComponent({
	name: 'MobileAsideComponent',
  mixins: [CategoriesMixins],
	components: {
		AsideLinkComponent
	}
})
